import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/Login";
import InspectionTask from "@/views/InspectionTask";
import InspectionRecord from "@/views/InspectionRecord";
import RealTimeInspection from "@/views/RealTimeInspection";
import store from "@/store";
Vue.use(Router);
const routes = [
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/InspectionTask",
    name: "InspectionTask",
    component: InspectionTask,
    meta: { requiresAuth: true } // 是否需要登陆
  },
  {
    path: "/InspectionRecord",
    name: "InspectionRecord",
    component: InspectionRecord,
    meta: { requiresAuth: true } // 是否需要登陆
  },
  {
    path: "/RealTimeInspection",
    name: "RealTimeInspection",
    component: RealTimeInspection,
    meta: { requiresAuth: true } // 是否需要登陆
  }
];
const router = new Router({
  mode: "history",
  routes
});
// 对登陆状态进行判断
router.beforeEach((to, from, next) => {
  if (to.name !== "login") {
    if (to.meta.requiresAuth) {
      if (store.state.login) {
        next();
      } else {
        next({
          name: "Login"
        });
      }
    } else {
      next();
    }
  } else {
    next();
  }
});
// 导出
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js